import React, {
  useEffect,
  useContext,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";

// Custom components
import mapService from "@/services/mapService";
import MapContext from "@/components/Map/MapContext";

// OL
import OlBaseLayer from "ol/layer/Base";
import OlVectorLayer from "ol/layer/Vector";
import OlVectorSource from "ol/source/Vector";
import OlLayerGroup from "ol/layer/Group";

// Types
import { MapContextType } from "@/@types/context/MapContext";

type GeoBaseLayerSwitcherProps = {
  mapId: number;
  setBaseLayersCollection: React.Dispatch<
    React.SetStateAction<Array<OlBaseLayer> | undefined>
  >;
  allowNoLayer?: boolean;
};

function GeoAPIBaseLayers(props: GeoBaseLayerSwitcherProps) {
  const context: MapContextType | null = useContext(MapContext);
  const { t } = useTranslation();
  const { setBaseLayersCollection, mapId, allowNoLayer = false } = props;

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (context?.map) {
      mapService.getBaseLayers(mapId, t).then((olGroup: OlLayerGroup) => {
        let coll;
        if (olGroup) {
          if (allowNoLayer) {
            coll = olGroup.getLayers();
            const solidColorLayer = new OlVectorLayer({
              source: new OlVectorSource({}),
            });
            solidColorLayer.set("id", "base-solid");
            solidColorLayer.set("title", "N/A");
            solidColorLayer.set("type", "base");
            solidColorLayer.set("baseLayer", true);
            solidColorLayer.setVisible(false);

            coll.insertAt(0, solidColorLayer);
            olGroup.setLayers(coll);
          }
          const mapLayers = context?.map?.getLayers();
          if (mapLayers) {
            mapLayers.remove(olGroup);
            mapLayers.insertAt(0, olGroup);
          }
        }

        if (mounted.current) {
          setBaseLayersCollection(
            olGroup ? olGroup.getLayers().getArray() : []
          );
        }
      });
    }
  }, [context?.map]);

  return null;
}

export default GeoAPIBaseLayers;
